import { UseFormProps } from 'react-hook-form';

export const DEFAULT_FORM_CONFIG = {
  reValidateMode: 'onBlur',
  mode: 'all'
} as UseFormProps;
